import React, { useEffect, useState } from "react";

const ReviewStrip = () => {
  const [reviews, setReviews] = useState([]);
  const [index, setIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [avatarError, setAvatarError] = useState(false);

  useEffect(() => {
    setAvatarError(false);
  }, [index]);

  useEffect(() => {
    let cancelled = false;
    fetch("/reviews.json")
      .then((res) => (res.ok ? res.json() : []))
      .then((data) => {
        if (!cancelled && Array.isArray(data)) setReviews(data);
      })
      .catch(() => {
        if (!cancelled) setReviews([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  if (loading || reviews.length === 0) return null;

  const current = reviews[index];
  const goPrev = () => { setAvatarError(false); setIndex((i) => (i <= 0 ? reviews.length - 1 : i - 1)); };
  const goNext = () => { setAvatarError(false); setIndex((i) => (i >= reviews.length - 1 ? 0 : i + 1)); };
  const showAvatar = current.avatarUrl && !avatarError;
  const initials = (current.name || "?")
    .split(/\s+/)
    .map((w) => (w[0] || "").toUpperCase())
    .slice(0, 2)
    .join("");

  return (
    <section className="review-strip" aria-label="Reviews">
      <h2 className="review-strip__heading">Happy &amp; Satisfied Faces</h2>
      <p className="review-strip__subheading">
        Here’s what some of our users say about Ahavibes.xyz.
      </p>
      <div className="review-strip__carousel">
        <button
          type="button"
          className="review-strip__arrow review-strip__arrow--prev"
          aria-label="Previous review"
          onClick={goPrev}
        >
          ‹
        </button>
        <div className="review-strip__card-wrap">
        <div className="review-strip__card">
          <div className="review-strip__content">
            <span className="review-strip__quote" aria-hidden="true">
              "
            </span>
            <p className="review-strip__text">{current.text}</p>
            <div className="review-strip__stars" aria-label={`${current.stars} out of 5 stars`}>
              {Array.from({ length: current.stars || 5 }, (_, i) => (
                <span key={i} className="review-strip__star" aria-hidden="true">
                  ★
                </span>
              ))}
            </div>
          </div>
          <div className="review-strip__card-footer">
            <div className="review-strip__avatar-wrap">
              {showAvatar ? (
                <img
                  src={current.avatarUrl}
                  alt=""
                  className="review-strip__avatar"
                  width={80}
                  height={80}
                  onError={() => setAvatarError(true)}
                />
              ) : (
                <span className="review-strip__initials" aria-hidden="true">
                  {initials}
                </span>
              )}
            </div>
            <div className="review-strip__meta">
              <p className="review-strip__name">
                {current.linkedinUrl ? (
                  <a
                    href={current.linkedinUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="review-strip__name-link"
                  >
                    {current.name}
                  </a>
                ) : (
                  current.name
                )}
              </p>
              <p className="review-strip__title">{current.title}</p>
            </div>
          </div>
        </div>
        </div>
        <button
          type="button"
          className="review-strip__arrow review-strip__arrow--next"
          aria-label="Next review"
          onClick={goNext}
        >
          ›
        </button>
      </div>
      <div className="review-strip__dots" aria-hidden="true">
        {reviews.map((_, i) => (
          <button
            key={i}
            type="button"
            className={`review-strip__dot ${i === index ? "review-strip__dot--active" : ""}`}
            aria-label={`Go to review ${i + 1}`}
            onClick={() => setIndex(i)}
          />
        ))}
      </div>
    </section>
  );
};

export default ReviewStrip;
